import axios from "axios";

/*
apiDataList shape: [
    {
        "type": 4,
        "ip": "54.83.179.135",
        "port": "18080"
    }
]
*/
// This Is To Get The Axios Instance For The API Dinamicly

export function computeAxiosInstance(type, defalutType, apiDataList, apikey) {
  let apiData = apiDataList.find((item) => item.type === type);
  if (!apiData) {
    apiData = apiDataList.find((item) => item.type === defalutType);
  }
  if (!apiData) {
    throw new Error("no apiData");
  }
  const { ip, port } = apiData;
  var header = {
    apikey: `${apikey}`,
    "x-bang-api-key": `${apikey}`
  };
  return axios.create({
    baseURL: `${
      typeof window === "object" ? window?.location?.protocol : "http:"
    }//${ip}:${port}`,
    headers: header,
  });
}
